import { defineStore } from 'pinia'
import { updateBodyClass, updateTitle, updateDomValueBySetting, updateSelectorClass, updateHtmlClass, updateHtmlAttr, updateColorRootVar, updateStorage } from '../../utilities/setting'
import { setFontFamily } from '@/utilities/root-var'
import { initialState as state, defaultState, dropdown } from './state'
import _ from 'lodash'

const DefaultSetting = defaultState.setting

const Choices = {
  SidebarShow: DefaultSetting.sidebar_show.choices,
  HeaderBanner: DefaultSetting.header_banner.choices,
  HeaderNavbarStyle: DefaultSetting.header_navbar.choices,
  NavbarShow: DefaultSetting.navbar_show.choices,
  SidebarMenuStyle: DefaultSetting.sidebar_menu_style.choices,
  FooterStyle: DefaultSetting.footer_style.choices,
  SidebarType: DefaultSetting.sidebar_type.choices,
  MenuColor: DefaultSetting.sidebar_color.choices,
  pagestyle: DefaultSetting.page_layout.choices,
  SchemeChoice: DefaultSetting.theme_scheme.choices,
  ColorChoice: DefaultSetting.theme_color.choices,
  StyleAppearanceChoice: DefaultSetting.theme_style_appearance.choices,
  FSChoice: DefaultSetting.theme_font_size.choices,
  Animation: DefaultSetting.theme_transition.choices,
  CardStyle: DefaultSetting.card_style.choices
}
const createSettingObj = (state) => {
  return {
    saveLocal: state.saveLocal,
    storeKey: state.storeKey,
    setting: _.cloneDeep(state.setting)
  }
}

export const useSetting = defineStore('setting', {
  state: () => ({ ...state, dropdown }),
  getters: {
    carts: (state) => state.dropdown.carts,
    app_name_value: (state) => state.setting.app_name.value,
    theme_scheme_value: (state) => state.setting.theme_scheme.value,
    theme_scheme_direction_value: (state) => state.setting.theme_scheme_direction.value,
    sidebar_show_value: (state) => state.setting.sidebar_show.value,
    sidebar_color_value: (state) => state.setting.sidebar_color.value,
    sidebar_menu_style_value: (state) => state.setting.sidebar_menu_style.value,
    theme_font_size_value: (state) => state.setting.theme_font_size.value,
    header_banner_value: (state) => state.setting.header_banner.value,
    default_saveLocal: (state) => state.saveLocal,
    default_theme_transition: (state) => state.setting.theme_transition.value,
    page_layout_value: (state) => state.setting.page_layout.value,
    default_theme_style_appearance: (state) => state.setting.theme_style_appearance.value,
    default_body_font_family: (state) => state.setting.body_font_family.value,
    default_theme_scheme: (state) => state.setting.theme_scheme.value,
    theme_color_custom: (state) => state.setting.theme_color,
    theme_scheme_direction_custom: (state) => state.setting.theme_scheme_direction.value,
    card_style_value: (state) => state.setting.card_style.value,
    header_navbar_value: (state) => state.setting.header_navbar.value,
    footer_style_value: (state) => state.setting.footer_style.value,
    navbar_show_value: (state) => state.setting.navbar_show.value,
    sidebar_type_value: (state) => state.sidebar_type.value
  },
  actions: {
    setSetting(payload) {
      this.setting.card_style.value = payload.card_style.value
      this.setting.header_navbar.value = payload.header_navbar.value
      this.setting.footer_style.value = payload.footer_style.value
      this.setting.sidebar_color.value = payload.sidebar_color.value
      this.setting.sidebar_menu_style.value = payload.sidebar_menu_style.value
      this.setting.sidebar_type.value = payload.sidebar_type.value
      _.forEach(payload.theme_color.colors, (value, key) => {
        this.setting.theme_color.colors[key] = value
      })
      this.setting.theme_color.value = payload.theme_color.value
    },
    reset_state() {
      this.setting = defaultState.setting
      updateDomValueBySetting(this.setting, Choices)
      updateStorage(this.saveLocal, this.storeKey, createSettingObj(state))
    },
    save_local(payload) {
      if (typeof payload !== typeof undefined) {
        this.saveLocal = payload
      }
      const settingObj = {
        saveLocal: this.saveLocal,
        storeKey: this.storeKey,
        setting: _.cloneDeep(this.setting)
      }
      updateStorage(this.saveLocal, this.storeKey, settingObj)
    },
    header_banner(payload) {
      this.setting.header_banner.value = payload
      updateSelectorClass('.iq-navbar-header', Choices.HeaderBanner, this.setting.header_banner.value)
      updateStorage(this.saveLocal, this.storeKey, createSettingObj(state))
    },
    app_name(payload) {
      if (typeof payload !== typeof undefined) {
        this.setting.app_name.value = payload
      }
      updateTitle(this.setting.app_name.value)
      updateStorage(this.saveLocal, this.storeKey, createSettingObj(state))
    },
    theme_style_appearance(payload) {
      if (typeof payload !== typeof undefined) {
        this.setting.theme_style_appearance.value = payload
      }
      updateBodyClass(Choices.StyleAppearanceChoice, this.setting.theme_style_appearance.value)
      updateStorage(this.saveLocal, this.storeKey, createSettingObj(state))
    },
    page_layout(payload) {
      this.setting.page_layout.value = payload
      updateSelectorClass('.content-inner', Choices.pagestyle, this.setting.page_layout.value)
    },
    theme_transition(payload) {
      if (typeof payload !== typeof undefined) {
        this.setting.theme_transition.value = payload
      }
      updateBodyClass(Choices.Animation, this.setting.theme_transition.value)
      updateStorage(this.saveLocal, this.storeKey, createSettingObj(state))
    },
    theme_scheme_direction(payload) {
      if (typeof payload !== typeof undefined) {
        this.setting.theme_scheme_direction.value = payload
      }
      updateHtmlAttr({ prop: 'dir', value: this.setting.theme_scheme_direction.value })
      updateStorage(this.saveLocal, this.storeKey, createSettingObj(state))
    },
    theme_scheme(payload) {
      if (typeof payload !== typeof undefined) {
        this.setting.theme_scheme.value = payload
      }
      updateBodyClass(Choices.SchemeChoice, this.setting.theme_scheme.value)
      updateColorRootVar(this.setting.theme_scheme.value, this.setting.theme_color, Choices.ColorChoice)
      updateStorage(this.saveLocal, this.storeKey, createSettingObj(state))
    },
    theme_color(payload) {
      if (typeof payload !== typeof undefined) {
        _.forEach(payload.colors, (value, key) => {
          console.log(this.setting)
          this.setting.theme_color.colors[key] = value
        })
        this.setting.theme_color.value = payload.value
      }
      updateColorRootVar(this.setting.theme_scheme.value, this.setting.theme_color, Choices.ColorChoice)
      updateStorage(this.saveLocal, this.storeKey, createSettingObj(state))
    },
    theme_font_size(payload) {
      if (typeof payload !== typeof undefined) {
        this.setting.theme_font_size.value = payload
      }
      updateHtmlClass(Choices.FSChoice, this.setting.theme_font_size.value)
      updateStorage(this.saveLocal, this.storeKey, createSettingObj(state))
    },
    header_navbar(payload) {
      this.setting.header_navbar.value = payload
      updateSelectorClass('.iq-navbar', Choices.HeaderNavbarStyle, this.setting.header_navbar.value)
    },
    card_style(payload) {
      this.setting.card_style.value = payload
      updateBodyClass(Choices.CardStyle, this.setting.card_style.value)
    },
    sidebar_type(payload) {
      this.setting.sidebar_type.value = payload
      const payloadString = payload.toString()
      const newClass = payloadString.replace(/,/g, ' ')
      updateSelectorClass('[data-toggle="main-sidebar"]', Choices.SidebarType, newClass)
    },
    sidebar_color(payload) {
      this.setting.sidebar_color.value = payload
      updateSelectorClass('[data-toggle="main-sidebar"]', Choices.MenuColor, this.setting.sidebar_color.value)
    },
    sidebar_menu_style(payload) {
      this.setting.sidebar_menu_style.value = payload
      updateSelectorClass('[data-toggle="main-sidebar"]', Choices.SidebarMenuStyle, this.setting.sidebar_menu_style.value)
    },
    sidebar_show(payload) {
      this.setting.sidebar_show.value = payload
      updateSelectorClass('[data-toggle="main-sidebar"]', Choices.SidebarShow, this.setting.sidebar_show.value)
    },
    navbar_show(payload) {
      this.setting.navbar_show.value = payload
      updateSelectorClass('.navbar', Choices.NavbarShow, this.setting.navbar_show.value)
    },
    footer_style(payload) {
      this.setting.footer_style.value = payload
      updateSelectorClass('.footer', Choices.FooterStyle, this.setting.footer_style.value)
      updateStorage(this.saveLocal, this.storeKey, createSettingObj(state))
    },
    body_font_family(payload) {
      if (typeof payload !== typeof undefined) {
        this.setting.body_font_family.value = payload
      }
      setFontFamily('body', this.setting.body_font_family.value)
    },
    heading_font_family(payload) {
      if (typeof payload !== typeof undefined) {
        this.setting.heading_font_family.value = payload
      }
      setFontFamily('heading', this.setting.heading_font_family.value)
    }
  }
})
window.pinia = useSetting
